import axios from 'axios';

import {
  apiGetCsvHeaders,
} from 'constants/apiRouting';
import { handleErrors } from 'utils/api';


// object
export const CREATE_CSV_PENDING = 'CREATE_CSV_PENDING';
export const CREATE_CSV_FAIL = 'CREATE_CSV_FAIL';
export const CREATE_CSV_SUCCESS = 'CREATE_CSV_SUCCESS';
export const GET_CSV_HEADERS_PENDING = 'GET_CSV_HEADERS_PENDING';
export const GET_CSV_HEADERS_FAIL = 'GET_CSV_HEADERS_FAIL';
export const GET_CSV_HEADERS_SUCCESS = 'GET_CSV_HEADERS_SUCCESS';
export const UPDATE_CSV_PENDING = 'UPDATE_CSV_PENDING';
export const UPDATE_CSV_FAIL = 'UPDATE_CSV_FAIL';
export const UPDATE_CSV_SUCCESS = 'UPDATE_CSV_SUCCESS';
export const DESTROY_CSV_PENDING = 'DESTROY_CSV_PENDING';
export const DESTROY_CSV_FAIL = 'DESTROY_CSV_FAIL';
export const DESTROY_CSV_SUCCESS = 'DESTROY_CSV_SUCCESS';


export const getCsvHeaders = csvId => async (dispatch) => {
  dispatch({
    type: GET_CSV_HEADERS_PENDING,
    payload: {},
  });
  try {
    const response = await axios.get(
      apiGetCsvHeaders(csvId),
      { withCredentials: true },
    );
    dispatch({
      type: GET_CSV_HEADERS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: GET_CSV_HEADERS_FAIL,
      payload: {},
    });
    handleErrors(error, dispatch);
    if (error.response && error.response.status === 404) {
      return { name: 'NotFound' };
    }
  }
  return 'ok';
};

